import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { LockersComponent } from './lockers/lockers.component';
import { LockerDetailComponent } from './lockers/locker-detail/locker-detail.component';
import { ProvisionsComponent } from './provisions/provisions.component';
import { PersonsComponent } from './persons/persons.component';
import { PersonDetailComponent } from './persons/person-detail/person-detail.component';
import { ProvisionDetailComponent } from './provisions/provision-detail/provision-detail.component';
import { CallbackComponent } from './auth/callback/callback.component';
import { HomeComponent } from './home/home.component';
import { isLoggedIn } from './auth/is-logged-in.guard';
import { personDetailResolver } from './persons/resolvers/person-detail.resolver';
import { companiesResolver } from './persons/resolvers/companies.resolver';
import { provisionDetailResolver } from './provisions/resolvers/provision-detail.resolver';
import { lockerDetailResolver } from './lockers/resolvers/locker-detail.resolver';
import { lockerHistoryResolver } from './lockers/resolvers/locker-history.resolver';
import { hasPermission } from './auth/has-permission';
import { ClothingDetailComponent } from './clothing/clothing-detail/clothing-detail.component';
import { ClothingComponent } from './clothing/clothing.component';
import { clothingDetailResolver } from './clothing/resolvers/clothing-detail.resolver';
import { NewClothingDetailComponent } from './clothing/new-clothing-detail/new-clothing-detail.component';

export const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [isLoggedIn, hasPermission],
  },
  {
    path: 'auth',
    component: LoginComponent,
  },
  {
    path: 'auth/callback',
    component: CallbackComponent,
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'provisions',
    component: ProvisionsComponent,
    canActivate: [isLoggedIn, hasPermission],
  },
  {
    path: 'provisions/:id',
    component: ProvisionDetailComponent,
    canActivate: [isLoggedIn, hasPermission],
    resolve: {
      provisionRequest: provisionDetailResolver,
    },
  },
  {
    path: 'persons',
    component: PersonsComponent,
    canActivate: [isLoggedIn, hasPermission],
  },
  {
    path: 'persons/:id',
    component: PersonDetailComponent,
    canActivate: [isLoggedIn, hasPermission],
    resolve: {
      person: personDetailResolver,
      companies: companiesResolver,
    },
  },

  {
    path: 'lockers',
    component: LockersComponent,
    canActivate: [isLoggedIn, hasPermission],
  },
  {
    path: 'lockers/:id',
    component: LockerDetailComponent,
    canActivate: [isLoggedIn, hasPermission],
    resolve: {
      locker: lockerDetailResolver,
      lockerHistory: lockerHistoryResolver,
    },
  },
  {
    path: 'clothing',
    component: ClothingComponent,
    canActivate: [isLoggedIn, hasPermission],
  },
  {
    path: 'clothing/new-clothing',
    component: NewClothingDetailComponent,
    canActivate: [isLoggedIn, hasPermission],
    resolve: {
      companies: companiesResolver,
    },
  },
  {
    path: 'clothing/:id',
    component: ClothingDetailComponent,
    canActivate: [isLoggedIn, hasPermission],
    resolve: {
      clothing: clothingDetailResolver,
    },
  },
];
